import { defineMessages, useIntl } from 'react-intl';
import ExploreServiceFilters, { ExploreServiceTrailDifficulty } from '../../types/ExploreServiceFilters';
import getDifficultyIcon from '../../utils/getDifficultyIcon';
import { difficulties } from '../../utils/getValidDifficulties';
import useChipsFilterConfig from './useChipsFilterConfig';

const labels = defineMessages<ExploreServiceTrailDifficulty>({
  easy: { defaultMessage: 'Easy' },
  moderate: { defaultMessage: 'Moderate' },
  hard: { defaultMessage: 'Hard' },
  strenuous: { defaultMessage: 'Strenuous' }
});

const useDifficultyChipsConfig = (exploreServiceFilters: ExploreServiceFilters, onFiltersChange: (updatedFilters: ExploreServiceFilters) => void) => {
  const intl = useIntl();

  return useChipsFilterConfig({
    exploreServiceFilterKey: 'difficulty',
    exploreServiceFilters,
    getValueIcon: getDifficultyIcon,
    getValueLabel: difficulty => intl.formatMessage(labels[difficulty]),
    label: intl.formatMessage({ defaultMessage: 'Difficulty' }),
    onFiltersChange,
    values: difficulties
  });
};

export default useDifficultyChipsConfig;
